import React from 'react'

interface DurationSectionProps {
  createdAt: string
}

const DurationSection: React.FC<DurationSectionProps> = ({ createdAt }) => {
  const STRIPE_TEXT_PRIMARY = '#32325d'
  const STRIPE_TEXT_SECONDARY = '#6b7c93'

  const formatDate = (dateString: string) => {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  }

  const formattedDate = formatDate(createdAt)

  return (
    <div style={{ marginBottom: '16px' }}>
      <h6
        style={{
          color: STRIPE_TEXT_PRIMARY,
          marginBottom: '12px',
          fontWeight: 'bold',
          fontSize: '16px',
        }}
      >
        Created On:
      </h6>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <span style={{ color: STRIPE_TEXT_SECONDARY, fontSize: '14px' }}>
          {formattedDate}
        </span>
      </div>
    </div>
  )
}

export default DurationSection
